import { render, staticRenderFns } from "./gameNameExcludeTab.vue?vue&type=template&id=1b6d1f56&lang=pug"
import script from "./gameNameExcludeTab.vue?vue&type=script&lang=js"
export * from "./gameNameExcludeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports